export default __webpack_public_path__ + "/assets/m_big.png";